import * as React from 'react';
import { Input } from "reactstrap";

interface IProps {
	value: any;
	placeholder?: string;
	onChange?: any;
	onBlur?: any;
	id: string;
	type?: any;
	className?: string;
	isRequired?: boolean;
	isHover?: boolean;
	readonly?: boolean;
	pattern?: string;
	title?: string;
	maxLength?: number;
}
interface IState {
	hoverClass: string;
}

class DABTextBox extends React.Component<IProps, IState>  {
	state = { hoverClass: "" };
	constructor(props: any) {
		super(props);
		this.state = {
			hoverClass: this.props.isHover === true ? "label-edit" : " "
		}
		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleOnBlur = this.handleOnBlur.bind(this);
	}

	handleOnBlur(event) {
		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
	}

	handleOnChange(event) {
		if (this.props.onChange) {
			this.props.onChange(event);
		}
	}

	render() {
		return (
			<Input required={this.props.isRequired}
				type={this.props.type}
				className={"form-control " + this.state.hoverClass + " " + this.props.className}
				id={this.props.id} name={this.props.id}
				value={this.props.value}
				onChange={this.handleOnChange}
				onBlur={this.handleOnBlur}
				readOnly={this.props.readonly}
				pattern={this.props.pattern}
				title={this.props.title}
				maxLength={this.props.maxLength}
			/>)
	}
}

export default DABTextBox;